import * as Sentry from "@sentry/browser";
        
function handleSentryEvent(event){
    // Event payload
    // https://develop.sentry.dev/sdk/data-model/event-payloads/
    if (event.exception && event.exception.values) {
        // Exception payload, Exception Interface
        // https://develop.sentry.dev/sdk/data-model/event-payloads/exception/
        for (const ex of event.exception.values) {
            // ex.value is the error message
            // ex.type is the error name

            if (ex.type === "ErrorName") {
                // handle this ErrorName
            }
            
            if (ex.value && ex.value.toLowerCase().includes("Indexed Database server lost".toLowerCase())) {
                // logs only 10%
                if (Math.random() > 0.1) return null
                return {
                    ...event,
                    fingerprint: [
                        ...(event.fingerprint || []),
                        "connection-to-indexed-database-lost"
                    ],
                    exception: {
                        values: [
                            ...event.exception.values,
                            {
                                type: "CustomHandledError",
                                value: "Indexed Database server lost",
                            }
                        ]
                    }
                }
            }

            if (ex.value && ex.value.toLowerCase().includes("Object Not Found Matching Id".toLowerCase())) {
                if (Math.random() > 0.1) return null
                return {
                    ...event,
                    fingerprint: [
                        ...(event.fingerprint || []),
                        "object-not-found-matching-id"
                    ],
                    exception: {
                        values: [
                            ...event.exception.values,
                            {
                                type: "CustomHandledError",
                                value: "Object Not Found Matching Id",
                            }
                        ]
                    }
                }
            }

            if (ex.value && ex.value.toLowerCase().includes("e.contentWindow.postMessage".toLowerCase())) {
                if (Math.random() > 0.1) return null
                return {
                    ...event,
                    fingerprint: [
                        ...(event.fingerprint || []),
                        "e-contentWindow-postMessage"
                    ],
                    exception: {
                        values: [
                            ...event.exception.values,
                            {
                                type: "CustomHandledError",
                                value: "e.contentWindow.postMessage",
                            }
                        ]
                    }
                }
            }
        }
    }
    
    return event;
}

export function initSentry(){
    const prot = window.location.protocol
    if (prot !== 'http:' && prot !== 'https:'){
        sentry_dsn_conf = ''
    }
    // add debug: true to init param to debug
    Sentry.init({
        dsn: sentry_dsn_conf,
        integrations: [Sentry.globalHandlersIntegration({ onerror: true, onunhandledrejection: false })],
        release: js_app_version,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        beforeSend: handleSentryEvent
    });
}
